<div class="row mt-4">
  <div class="col-lg-12 col-xl-12 stretch-card">
    <div class="row flex-grow">
      <div class="col grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <div class="br-1 float-left pr-2 position-relative">
              <div class="tree-view float-left" style="max-width: 255px; min-width: 255px">
                <ul>
                  <ng-container *ngTemplateOutlet="renderNodes; context: { $implicit: device_hierarchy }"></ng-container>
                  <ng-template #renderNodes let-nodes>
                    <ul *ngIf="nodes?.length">
                      <li *ngFor="let node of nodes">
                        <span [class.active]="node.id === selected_device?.id" [style.cursor]="node.id ? 'pointer' : 'default'" (click)="onDeviceSelect(node)">
                          {{ node.name }}
                        </span>
                        <ng-container *ngIf="node.childrens?.length">
                          <ng-container *ngTemplateOutlet="renderNodes; context: { $implicit: node.childrens }"></ng-container>
                        </ng-container>
                      </li>
                    </ul>
                  </ng-template>
                </ul>
              </div>
            </div>

            <form #alertForm="ngForm" (ngSubmit)="onSubmit()">
              <h3>{{ selected_device?.name || 'Please select a device' }}</h3>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>Parameter</label>
                    <select class="form-control" name="Parameter" [(ngModel)]="alertFormModel.selectedParameter" required>
                      <option [ngValue]="null" disabled>Select parameter</option>
                      <option *ngFor="let param of parameters" [ngValue]="param.parameter">
                        {{ param?.description }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group mb-0">
                    <label>Threshold Values</label>
                  </div>
                  <div class="form-row">
                    <div class="col">
                      <div class="form-group">
                        <input type="number" placeholder="Min Val" class="form-control" name="minVal" [(ngModel)]="alertFormModel.minVal" required />
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <input type="number" placeholder="Max Val" class="form-control" name="maxVal" [(ngModel)]="alertFormModel.maxVal" required />
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label for="alarm-emails">Alarm Emails</label>
                    <input type="email" class="form-control" id="alarm-emails" name="alarmEmail" [(ngModel)]="alertFormModel.alarmEmail" placeholder="user@example.com" required />
                  </div>
                </div>

                <div class="col-sm-12">
                  <div class="form-group float-right mb-0">
                    <button type="submit" class="btn theme-primary-btn" [disabled]="alertForm.invalid || isLoading">
                      {{ isLoading ? 'Updating...' : 'Update Setting' }}
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <div class="mt-3">
              <div class="ag-theme-alpine" style="width: 100%; height: 300px;">
                <ag-grid-angular
                  [rowData]="emailAlerts"
                  [columnDefs]="columnDefs"
                  [defaultColDef]="defaultColDef"
                  class="ag-theme-alpine"
                  style="width: 100%; height: 100%;">
                </ag-grid-angular>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>